import React from 'react';
import CheckedSVG from "../../../../assets/images/Checked.svg"
import EmptyCheckBoxSVG from "../../../../assets/images/CheckBox_empty.svg"
const CustomCheckbox = ({ checked, onChange, className = '' }) => {
  return (
    <label className="relative inline-block">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only" // Hidden but accessible
      />
      <div 
        className={`
          w-5 h-5 
          cursor-pointer
          bg-no-repeat
          bg-center
          bg-contain
          ${checked ? 'bg-[#1A6D73] rounded' : ''}
          ${className}
        `}
        style={{
          backgroundImage: checked 
            ? `url(${CheckedSVG})`
            : `url(${EmptyCheckBoxSVG})`
        }}
      >
      </div>
    </label>
  );
};

export default CustomCheckbox;